import React, { Fragment } from 'react'
import moment from 'moment'
import { Heading, NotAvailable } from '@myxplor/ui'
import { formatAddress } from '../helpers'
import ImageService from './images/service.svg'
import ImageParent from './images/parent.svg'
import ImageChild from './images/child.svg'
import './styles.css'

const ImagePaths = {
  Child: ImageChild,
  Parent: ImageParent,
  Service: ImageService,
}

const AgreementDetails = ({ name, renderChildren, sectionType }) => (
  <div>
    <img
      src={ImagePaths[sectionType]}
      className="enrolmentApproval--heroImage"
      alt={`${sectionType}`}
    />
    <Heading small compact>
      {name}
    </Heading>
    <div className="enrolmentApproval--party">{sectionType}</div>
    {renderChildren}
  </div>
)

const PartiesToTheAgreement = ({ service, parent, child }) => (
  <div className="enrolmentApproval--partiesToAgreement">
    <AgreementDetails
      name={service.name}
      renderChildren={
        <Fragment>
          {formatAddress(service.address)}
          Tel: {service.phone_number ? service.phone_number : <NotAvailable name="Phone number" />}
        </Fragment>
      }
      sectionType="Service"
    />

    <AgreementDetails
      name={`${parent.first_name} ${parent.last_name}`}
      renderChildren={formatAddress(parent.address)}
      sectionType="Parent"
    />

    <AgreementDetails
      name={`${child.first_name} ${child.last_name}`}
      renderChildren={
        <Fragment>
          DOB: {child.dob ? moment(child.dob, 'YYYY-MM-DD').format('Do MMM YYYY') : <NotAvailable name="DOB" />}
        </Fragment>
      }
      sectionType="Child"
    />
  </div>
)

const MainRecord = ({ record }) => (
  <Fragment>
    <Heading>Complying Written Agreement</Heading>
    <p>
      <strong>We’ll keep this short and sweet:</strong> The Complying Written Agreement (CWA) is
      part of the new Child Care Subsidy (CCS) being rolled out by the Australian Federal
      Government. The CWA is an agreement between the care provider and parent/guardian which
      establishes the basis on which care will be provided to a child.
    </p>

    <p>You will need to approve this agreement and any future changes to your routine sessions.</p>

    <Heading small>Parties to the Agreement</Heading>
    <PartiesToTheAgreement {...record} />
  </Fragment>
)

export default MainRecord



// WEBPACK FOOTER //
// ./src/parent-agreement/views/main-record/index.jsx